export const additionalInfo = [
  {
    icon: 'project-documents',
    text: 'Keep track of your projects and documents',
  },
  { icon: 'home', text: 'Invite household to manage your home as a team' },
  { icon: 'connections', text: 'Share Pro referrals with your neighbours' },
  {
    icon: 'referral-solid',
    text: 'Book your next Pro through verified referrals',
  },
];

export const additionalInfoCommunity = [
  {
    icon: 'referral-solid',
    text: 'Share Pro referrals with your neighbours',
  },
  {
    icon: 'like',
    text: 'Build a friendlier community',
  },
  {
    icon: 'gift',
    text: 'Compete with other street communities for local rewards',
  },
];
